import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a98d0ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.ingeteam.com",
  target: "_blank"
}, "Ingeteam ", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "footer__legal"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookieBanner = _resolveComponent("CookieBanner")!
  const _component_CookieSettingsDialog = _resolveComponent("CookieSettingsDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["footer", { 'footer__wrapper__login': _ctx.isLoginRoute, 'footer__wrapper__nologin': !_ctx.isLoginRoute }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createTextVNode("|"),
          _createElementVNode("span", null, " v" + _toDisplayString(_ctx.webVersion), 1),
          (!_ctx.isLoginRoute)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "-m" + _toDisplayString(_ctx.motorVersion), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_4,
        (_ctx.isLoginRoute)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("a", {
                target: "_blank",
                href: _ctx.legaladviceurl
              }, _toDisplayString(_ctx.$t('footer.legaladvice')), 9, _hoisted_6),
              _createElementVNode("a", {
                target: "_blank",
                href: _ctx.privacypolicyurl
              }, _toDisplayString(_ctx.$t('footer.privacypolicy')), 9, _hoisted_7),
              _createElementVNode("a", {
                target: "_blank",
                href: _ctx.cookiespolicyurl
              }, _toDisplayString(_ctx.$t('cookies.cookiespolicy')), 9, _hoisted_8),
              _createElementVNode("button", {
                class: "button__link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setShowCookieSettingsDialog && _ctx.setShowCookieSettingsDialog(...args)))
              }, _toDisplayString(_ctx.$t('footer.cookiespolicy')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (!_ctx.hasCookies)
      ? (_openBlock(), _createBlock(_component_CookieBanner, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.ShowCookieSettingsDialog)
      ? (_openBlock(), _createBlock(_component_CookieSettingsDialog, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}